const RE = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
export const emailValidation = (value) => {
    return RE.test(value)
}